// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectWithIcon-wrapper [class*=contextMenuWrapper] {
  z-index: 1;
}
.SelectWithIcon-wrapper [class^=dist_menuItemButton] {
  min-width: 152px;
}
.SelectWithIcon-wrapper .SelectWithIcon-button {
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 8px 12px;
  border: 1px solid var(--color_neutral_400);
  border-radius: 6px;
}
.SelectWithIcon-wrapper .SelectWithIcon-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.SelectWithIcon-wrapper .SelectWithIcon-button .SelectWithIcon-selected {
  text-align: start;
  width: 90px;
  font-size: 14px;
  color: var(--color_neutral_800);
}`, "",{"version":3,"sources":["webpack://./src/components/select-with-icon/select-with-icon.styles.scss"],"names":[],"mappings":"AACE;EACE,UAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,kBAAA;AAFJ;AAII;EACE,mBAAA;EACA,YAAA;AAFN;AAKI;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,+BAAA;AAHN","sourcesContent":[".SelectWithIcon-wrapper {\n  [class*=\"contextMenuWrapper\"] {\n    z-index: 1;\n  }\n\n  [class^=\"dist_menuItemButton\"] {\n    min-width: 152px;\n  }\n\n  .SelectWithIcon-button {\n    display: flex;\n    align-items: center;\n    column-gap: 8px;\n    padding: 8px 12px;\n    border: 1px solid var(--color_neutral_400);\n    border-radius: 6px;\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.5;\n    }\n\n    .SelectWithIcon-selected {\n      text-align: start;\n      width: 90px;\n      font-size: 14px;\n      color: var(--color_neutral_800);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
